import { render, staticRenderFns } from "./SysCjProject.vue?vue&type=template&id=064a9596"
import script from "./SysCjProject.vue?vue&type=script&lang=js"
export * from "./SysCjProject.vue?vue&type=script&lang=js"
import style0 from "./SysCjProject.vue?vue&type=style&index=0&id=064a9596&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports